module.exports = __webpack_public_path__ + "static/media/mobile-order-bullet.7dbf5070.svg";